<template>
  <div class="searchTutor-wrapper">
    <input
      type='text'
      @click="$bvModal.show('bv-modal-search-tutor')"
      :value="tutor && tutor.name"
    >
    <b-modal id="bv-modal-search-tutor" size="xl" hide-footer>
      <TutorList v-model="tutor" />
    </b-modal>

    <span class="chancel-button" @click="unsetTutor">
      <font-awesome-icon  icon="times"/>
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { Tutor } from '@/store/tutors/types'
import { Component, Emit, Prop } from 'vue-property-decorator'
import TutorList from '@/components/parts/modal/tutorList/AllList.vue';

@Component({
  components: {
    TutorList,
  },
})
export default class SearchTutor extends Vue {
  @Prop()
  private value!: Tutor

  public get tutor(): Tutor|null {
    return this.value
  }

  public set tutor(tutor: Tutor|null) {
    this.$bvModal.hide('bv-modal-search-tutor')
    this.$emit('input', tutor)
  }

  public unsetTutor() {
    this.tutor = null
  }
}
</script>

<style scoped>
  input[type="text"] {
    cursor: pointer;
    padding: 5px 30px 5px 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width:100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom:5px;
  }

  .searchTutor-wrapper {
    position: relative;
  }

  .chancel-button {
    position: absolute;
    top: 7px;
    margin: auto;
    right: 10px;
    cursor: pointer;
    z-index: 999;
  }

  .chancel-button:hover {
    opacity:.5;
  }
</style>
